import { useEffect } from "react";
import { trackPageView } from "./Telemetry";

export default function HashPageTracker() {
  useEffect(() => {
    function sendPageTelemetry() {
      const hash = window.location.hash.replace(/^#/, "") || "/";
      trackPageView(hash);
    }

    // Trigger on initial load
    sendPageTelemetry();

    // Listen for hash changes
    window.addEventListener("hashchange", sendPageTelemetry);

    return () => {
      window.removeEventListener("hashchange", sendPageTelemetry);
    };
  }, []);

  return null;
}
